module.exports = __webpack_public_path__ + "static/media/002.19c59a00.jpg";